<template>
   <div class="news">
         <div class="lestNav"  :style="{ minHeight: height + 'px' }"> 
            <span style="font-size:16px;font-weight:bold;">资讯</span>
            <span style="padding-left:30px" v-for="(item,index) in menuList" :key="index" :class="{ active:index==activeIndex }" @click="getDetail(index,item)">{{ item.categoryName }}</span>
        </div>  
        <div class="main-content" :style="{ minHeight: height + 'px' }">
            <div v-if="loading" class="loading-content"><a-spin /></div>
            <div class="list" v-if="dataList.length>0 && !loading">
                <div class="main" v-for="(item,index) in dataList" :key="index">
                    <div class="img" style="cursor:pointer;" @click="$router.push({ path:'/details',query:{ id:item.id,activeIndex:activeIndex }})"><img :src="item.titleImage" width="200" height="130"></div>
                    <div class="content">
                        <div class="title"  @click="$router.push({ path:'/details',query:{ id:item.id,activeIndex:activeIndex }})" style="cursor:pointer;">{{ item.contentTitle }}</div>
                        <div class="intro">{{ item.contentMark }}</div>
                        <div class="time-detail">
                            <span>{{ item.createTime }}</span>
                            <!-- <span style="cursor:pointer;" @click="$router.push({ path:'/details',query:{ id:item.id }})">查看详情>></span></span></span> -->
                        </div>
                    </div>
                </div>
                <pagination ref="pagination" :defaultPageSize="params.pageSize" :current="params.pageNum" :total="total" @getList="getList"></pagination>
            </div>
            <div class="none-content" v-if="dataList.length == 0 && !loading">
                <a-icon class="none" type="meh" />
                <span>未查询到相关数据</span>
            </div>
        </div>      
   </div>    
</template>

<script>
export default {
    data(){
        return{
            menuList:[],
            height:'',
            activeIndex:0,
            loading:false,
            dataList:[],
            total:'',
            params:{
              pageSize:5,
              pageNum:1
           },
        }
    },
    created(){
        this.getNavList();
        
    },
    mounted(){
       this.$parent.current = '8';
       this.height = document.body.clientHeight - 85;
    },
    methods:{
        getDetail(index,item){
            this.activeIndex = index;
            this.params.pageNum = 1;
            this.getdetailList(item.id)
        },
        getNavList(){
            let params = {
                parentId:'2'
            }
            this.$https.get('/portal/content/getSecondCategory',{params:params}).then(res=>{
                this.menuList = res;
                if(this.$route.query.activeIndex){
                    this.activeIndex = this.$route.query.activeIndex;
                    this.getdetailList(res[this.activeIndex].id)
                }else{
                    this.getdetailList(res[0].id);
                }
            })
        },
        getList(page){
            this.params.pageNum = page;
            this.getdetailList(this.params.id);
        },
        getdetailList(id){
            this.loading = true;
            this.params.id = id;
            this.$https.get('/portal/content/getContentByCategory',{params:this.params}).then(res=>{
                this.loading = false;
                if(res.code == 200){
                    this.dataList = res.rows;
                    this.total = Number(res.total);
                    console.log(this.total)
                }else{
                    this.$message.error(res.msg);
                }
            }).catch(error=>{
                this.loading = false;
            })
        }
    }
}
</script>

<style lang="less" scoped>
.news{
     width: 1300px;
    margin:0 auto;
    background: #fff;
    display: flex;
    .lestNav{
            display: flex;
            flex-direction: column;
            width: 200px;
            border-right:10px solid #f0f2f5;
            cursor: pointer;
            span{
                line-height: 50px;
                padding-left: 20px;
                border-bottom: 1px solid #eeeeee;
            }
            .active{
                background: #1890ff;
                color: #fff;
            }
        }
    .main-content{
         width: 1090px;
        .loading-content{
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .none-content{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .none{
                font-size:70px;
                font-weight: bold;
                margin-bottom:30px;
            }
        }
        .list{
            padding:20px;
            .main{
                display: flex;
                padding-bottom:10px;
                margin-top:10px;
                border-bottom: 1px solid #eeeeee;
                .img{
                    width: 200px;
                    height: 130px;
                    overflow: hidden;
                }
                .content{
                    width: 840px;
                    margin-left:10px;
                    .title{
                        font-size: 14px;
                        font-weight: bold;
                        line-height: 35px;
                        height: 35px;
                    }
                    .intro{
                        color: #9999a2;
                        font-size: 12px;
                        height: 30px;
                        line-height: 30px;
                    }
                    .time-detail{
                        margin-top:40px;
                        display: flex;
                        height: 25px;
                        line-height: 25px;
                        justify-content: space-between;
                    }
                }
            }
        }
    }
}
</style>